(function () {
    'use strict';

    angular.module("imApp").factory("stockTransMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1873,
                    parameters: parms || {}
                });
            },
            listAllocations: function (parms) {
                return $ihttp.post({
                    method: 1874,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
